export type AspectRatio = `${number}:${number}` | `${number}/${number}` | number | "auto";

export const getAspectRatioStyle = (aspectRatio?: AspectRatio): React.CSSProperties => {
  const baseStyle: React.CSSProperties = {
    position: "relative",
    height: "100%",
    width: "100%"
  };
  if (!aspectRatio) return {};
  if (typeof aspectRatio === "number") return { ...baseStyle, aspectRatio };

  const m = aspectRatio.replace(":", "/").match(/^(\d+)\/(\d+)$/);
  if (m)
    return {
      ...baseStyle,
      aspectRatio: +m[1] / +m[2]
    };
  return { ...baseStyle, aspectRatio: 16 / 9 };
};
